//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Server.WebAccess.Agile
//----------------------------------------------------------

/**
 * Points (i.e. contribution ids) for targeting all agile hubs.
 */
export module AgileHubContributionIds {
    export const BacklogConfiguration_DataProvider = "ms.vss-work-web.agile-backlog-configuration-data-provider";
    export const TeamSetting_DataProvider = "ms.vss-work-web.team-wit-settings-data-provider";
    export const Settings_Route = "ms.vss-admin-web.project-admin-hub-route";
}

export module AgileHubServerConstants {
    export const FilterRegistryKeyFormat = "{0}/{1}/Filter";
    export const HelpLinkPlanAnIteration = "https://go.microsoft.com/fwlink/?LinkId=2046708";
    export const TeamMRUKey = "Agile/Team";
}

export module AgileQueryParameters {
    export const TeamId = "teamid";
    export const Level = "level";
}

export module AgileRouteParameters {
    export const Name = "name";
    export const Project = "project";
    export const Pivot = "pivot";
    export const Iteration = "iteration";
    export const TeamName = "teamName";
    export const BacklogLevel = "backlogLevel";
    export const Report = "report";
    export const Id = "id";
    /**
     * This parameter is not surfaced in the user-visible url but instead it's used for contribution constraints
     */
    export const ViewName = "viewname";
}

export module BacklogConstants {
    export const SprintForecastVelocity = "AgileBacklog.SprintForecastVelocity";
    export const DefaultSprintForecastVelocity = 10;
    export const ShowForecastFilter = "AgileBacklog.ShowForecastFilter";
    export const ActionNameIteration = "Iteration";
    export const NumberOfIterationsInVelocity = 5;
    export const ShowInProgressFilter = "AgileBacklog.ShowInProgressFilter";
    export const ShowCompletedChildItemsFilter = "AgileBacklog.ShowCompletedChildItemsFilter";
    export const ParentColumnRefName = "System.Backlog.Parent";
}

export module BacklogsHubConstants {
    export const HUB_NAME = "Backlogs";
    export const BacklogPivot = "backlog";
    export const AnalyticsPivot = "analytics";
    export const InProgressParameter = "inProgress";
    export const CompletedChildItemsParameter = "completedChildItems";
    export const InProgressSetting = "Agile/BacklogsHub/InProgressFilter";
    export const CompletedChildItemsSetting = "Agile/BacklogsHub/CompletedChildItemsFilter";
    export const ShowParentsQueryParameter = "showParents";
    export const RightPaneQueryParameter = "rightPane";
    export const ShowParentsSetting = "Agile/BacklogsHub/ShowParentsFilter";
    export const ForecastingParameter = "forecasting";
    export const ForecastingSetting = "Agile/BacklogsHub/Forecasting";
    export const PaneParameter = "pane";
    export const PaneSetting = "Agile/BacklogsHub/Pane";
    export const MruBacklogKey = "Agile/BacklogsHub/BacklogId";
    export const HUB_CONTRIBUTION_ID = "ms.vss-work-web.backlogs-hub";
    export const PRODUCTBACKLOG_DATAPROVIDER_ID = "ms.vss-work-web.backlogs-hub-backlog-data-provider";
    export const HEADER_DATAPROVIDER_ID = "ms.vss-work-web.backlogs-hub-content-header-data-provider";
    export const ContentRouteContributionId = "ms.vss-work-web.backlogs-content-route";
    export const DirectoryRouteContributionId = "ms.vss-work-web.backlogs-directory-route";
    export const LegacyBacklogsHubContributionRouteId = "ms.vss-work-web.agile-route";
    export const DirectoryViewName = "directory";
    export const WorkItemIds = "workItemIds";
    export const ColumnOptionsFormat = "Agile/BacklogsHub/ColumnOptions/{0}";
    export const CFDReportName = "cfd";
    export const VelocityReportName = "velocity";
}

export module BoardsHubConstants {
    export const HUB_NAME = "Boards";
    export const HUB_CONTRIBUTION_ID = "ms.vss-work-web.boards-hub";
    export const TEAM_BOARD_CONTENT_ROUTE_CONTRIBUTION_ID = "ms.vss-work-web.team-board-content-route";
    export const EMBEDDED_ROUTE_CONTRIBUTION_ID = "ms.vss-work-web.microsoft-teams-board-tab-content-route";
    export const DIRECTORY_ROUTE_CONTRIBUTION_ID = "ms.vss-work-web.boards-directory-route";
    export const TEAM_BOARD_CONTENT_HEADER_DATAPROVIDER_ID = "ms.vss-work-web.team-board-content-header-data-provider";
    export const TEAM_BOARD_CONTENT_DATAPROVIDER_ID = "ms.vss-work-web.team-board-content-data-provider";
    export const HubCategoryReferenceName = "hubCategoryReferenceName";
    export const WorkItemIds = "workItemIds";
    export const MruBacklogKey = "Agile/BoardsHub/BacklogId";
}

export module BoardsHubRoutingConstants {
    export const AllPivot = "all";
    export const MinePivot = "mine";
    export const BoardPivot = "board";
    export const AnalyticsPivot = "analytics";
    export const DirectoryViewName = "directory";
}

export module BoardsHubServerConstants {
    export const ContentContributionRouteId = "ms.vss-work-web.team-board-content-route";
    export const DirectoryContributionRouteId = "ms.vss-work-web.boards-directory-route";
    export const EmbeddedContentContributionRouteId = "ms.vss-work-web.microsoft-teams-board-tab-content-route";
    export const EmbeddedQueryParameter = "embedded";
}

export module DirectoryConstants {
    export const KeywordFilterItemKey = "DirectoryFilter-Keyword";
    export const TeamFilterItemKey = "DirectoryFilter-Team";
}

export module FavoriteConstants {
    export const TeamName = "TeamName";
}

/**
 * Points (i.e. contribution ids) for targeting right panel extensions.
 */
export module RightPanelExtensionIds {
    export const PortfolioBacklog = "ms.vss-work-web.portfolio-backlog-toolpane";
    export const RequirementBacklog = "ms.vss-work-web.requirement-backlog-toolpane";
    export const IterationBacklog = "ms.vss-work-web.iteration-backlog-toolpane";
}

export module SprintsHubBackCompatRoutingConstants {
    export const SprintBacklogPivot = "iteration";
}

export module SprintsHubConstants {
    export const HUB_NAME = "Sprints";
    export const HUB_CONTRIBUTION_ID = "ms.vss-work-web.sprints-hub";
    export const RIGHT_PANEL_DEFAULT_SIZE_PX = 420;
    export const ContentPivotSetting = "Agile/SprintsHub/Navigation/ContentPivot";
    export const DirectoryPivotSetting = "Agile/SprintsHub/Navigation/DirectoryPivot";
    export const IterationSetting = "Agile/SprintsHub/Navigation/Iteration";
    export const PivotSettings = "Agile/SprintsHub/Navigation/PivotSettings";
    export const PeopleSwitcher = "people-switcher";
    export const ColumnOptions = "Agile/SprintsHub/IterationBacklogColumnOptions";
}

export module SprintsHubRoutingConstants {
    export const AllPivot = "all";
    export const MinePivot = "mine";
    export const NewPivot = "new";
    export const TaskboardPivot = "taskboard";
    export const SprintBacklogPivot = "backlog";
    export const CapacityPivot = "capacity";
    export const AnalyticsPivot = "analytics";
    export const DirectoryViewName = "directory";
}

export module SprintsHubServerConstants {
    export const ContributionRouteId = "ms.vss-work-web.sprints-content-route";
    export const TeamAgnosticContributionRouteId = "ms.vss-work-web.sprints-route";
    export const DirectoryContributionRouteId = "ms.vss-work-web.sprints-directory-route";
    export const SprintsHubNavigationSettings = "Agile/SprintsHub/NavigationSettings";
}

export module SprintsHubStorageConstants {
    export const AgileBoardFilter = "AgileBoardFilter.";
    export const Group = "group";
}

export module TeamPanelConstants {
    export const TeamId = "teamId";
    export const ProjectId = "projectId";
    export const TeamName = "teamName";
    export const ProjectName = "projectName";
}

export module WorkItemsConstants {
    export const WorkItemsFormContributionId = "ms.vss-work-web.work-items-form-route-with-id";
    export const WorkItemFormRouteIdParam = "id";
}
